

<com-modal [config]="roleManagementModalConfig">
    <div class="row">
        <ng-container *ngIf=" flow === 'domain'">
            <label class="col-12 fw-semibold required mb-0 font-size-95">Role Level</label>
            <div class="col-12 mb-3">
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                      <a class="nav-link {{roleLevel === 'top' ? 'active' : ''}} font-size-90 py-1" (click)="$event.preventDefault(); roleLevel = 'top'; resetViewData(); getUserRoles();">Top</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link {{roleLevel === 'resource' ? 'active' : ''}} font-size-90 py-1" (click)="$event.preventDefault(); roleLevel = 'resource'; resetViewData(); getApplicationResources();">Resource</a>
                    </li>
                  </ul>
            </div>
        </ng-container>

        <ng-container *ngIf="roleLevel === 'top'">
            <div class="col-12 col-sm-6 form-label-group">
                <custom-select class="form-group form-label-group" [field]="(applicationSelect)" [clearable]="false" [multiSelect]="false" [pristine]="true" (selectedArrayEvent)="selectedApplication = $event?.[0]; rolesToBeShown = appNamesMap[flow === 'admin' ? appName : 'currentDomain'][selectedApplication] ?? ''"> </custom-select>
            </div>
        </ng-container>
        <ng-container *ngIf="flow === 'domain'">
            <ng-container *ngIf="roleLevel === 'resource'">
                <div class="col-12 col-sm-6 form-label-group">
                    <custom-select class="form-group form-label-group" [field]="(resourceTypeSelect)" [clearable]="false" [multiSelect]="false" [pristine]="true" (selectedArrayEvent)="selectedAppResourceId = $event?.[0]; getDomainResources(selectedAppResourceId); selectedDomainResourceId = -1; rolesToBeShown = [];"> </custom-select>
                </div>
                <div class="col-12 col-sm-6 form-label-group">
                    <custom-select class="form-group form-label-group" [field]="(resourceValueSelect)" [clearable]="false" [multiSelect]="false" [pristine]="true" (selectedArrayEvent)="selectedDomainResourceId = $event?.[0]; getAllRoles(selectedAppResourceId, selectedDomainResourceId); getUserRoles(selectedDomainResourceId);"> </custom-select>
                </div>
            </ng-container>
        </ng-container>
    </div>
    <div class="row">
        <div class="col-12 table-responsive mt-3 scrollable-contents">
            <table class="table table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th>Role</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let role of rolesToBeShown">
                        <td>
                            <div class="form-check ps-4 pe-1 py-2">
                                <input class="form-check-input pointer" name="abc" id="checkbox-for-role-{{role?.id}}" type="checkbox" [checked]="isRoleChecked(role?.id)" (change)="roleStateRetentionMethod(roleCheckboxSpy, role)" #roleCheckboxSpy>
                                <label class="form-check-label mt-0" for="checkbox-for-role-{{role?.id}}"></label>
                            </div>
                        </td>
                        <td (click)="roleCheckboxSpy?.click();">
                            <p class="pointer mb-0">{{role?.roleName}}</p>
                        </td>
                        <td>{{role?.description || '-'}}</td>
                    </tr>
                </tbody>
              </table>
        </div>
    </div>
</com-modal>